import request from '@/utils/api/request';
import absoluteLink from '@/utils/formatting/absolute-link';

const DEFAULT_FILE_NAME = 'Fixtender_file';

// Выполняет скачивание и возвращает файл или ошибку для обработки
const downloadByLink = async ({ link, query = {}, fileName, withoutAuthorization = false }) => {
  try {
    const requestConfig = {
      responseType: 'blob',
      params: query,
    };
    // При скачивании файлов из aws требуется НЕ передавать токены авторизации,
    // конструкцией ниже убираем токены авторизации если был передан флаг
    if (withoutAuthorization) {
      requestConfig.transformRequest = [
        (data, headers) => {
          delete headers.Authorization;
          return data;
        },
      ];
    }
    const { data, headers } = await request.get(absoluteLink(link), requestConfig);

    const file = new Blob([data], { type: data.type });

    // Указанное имя > получение названия из меты ответа > дефолтное по умолчанию
    const computedFileName =
      fileName ||
      headers['content-disposition']?.split(';')[1]?.split('=')[1]?.replaceAll('"', '') ||
      DEFAULT_FILE_NAME;

    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = URL.createObjectURL(file);
    a.download = computedFileName;

    a.click();
    URL.revokeObjectURL(file);
    return { fileName: computedFileName, file };
  } catch (e) {
    console.error(e);
    // Снаружи мы получаем или файл, или принимаем ошибку для обработки и вывода
    return e;
  }
};

export default downloadByLink;
